import { Environment, onEnvironmentChange } from '@hub/shared'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'

import './help.page.scoped.scss'

const HelpPageComponent = (props: any) => {
  const onEnvironmentChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [t] = useTranslation('helpPage')
  const [cards, setCards] = useState<
    Array<{
      name: string
      icon: string
      link: string
    }>
  >([])

  useEffect(() => {
    onEnvironmentChangeSubscription.current = onEnvironmentChange.subscribe((environments: Environment) => {
      setCards([
        {
          name: 'central',
          icon: 'circle-info',
          link: environments?.squidProducts?.creators,
        },
        {
          name: 'chat',
          icon: 'comments',
          link: `${environments?.externalLinks?.linkWhatsapp}&text=${t('cards.chat.text')}`,
        },
        {
          name: 'blog',
          icon: 'screen-users',
          link: `${environments?.squidProducts?.vidaDeInfluencer}/?utm_source=hub&utm_medium=menu&utm_campaign=me_ajuda`,
        },
      ])
    })
    return () => onEnvironmentChangeSubscription?.current?.unsubscribe()
  }, [t])

  useEffect(() => {
    if (props?.configs?.whatsappLink) {
      setCards((oldCards) =>
        oldCards?.map((c) => {
          if (c.name === 'chat') {
            return {
              ...c,
              link: props.configs.whatsappLink,
            }
          }
          return c
        })
      )
    }
  }, [props, setCards])

  return (
    <div className="help-page box">
      <ul className="card-list">
        {cards
          .filter((card) => card.name !== 'blog')
          .filter((card) => (card.name === 'central' && !props?.configs?._id) || card.name !== 'central')
          ?.map((card, index) => (
            <li className="card-help box" key={index}>
              <i className={`fa-regular fa-${card.icon} big-icon`} />
              <span className="texts">
                <h5>{t(`cards.${card.name}.title`)}</h5>
                <p>{t(`cards.${card.name}.description`)}</p>
                <a href={card?.link} target="_blank" className="button button-primary small">
                  <i className="fa-regular fa-arrow-up-right-from-square mr-2" />
                  {t(`cards.${card.name}.link`)}
                </a>
              </span>
            </li>
          ))}
      </ul>
    </div>
  )
}

export default HelpPageComponent
